var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Button",class:_vm.getTint(),on:{"click":function($event){return _vm.onClick()}}},[_vm._v("\n  "+_vm._s(_vm.trans('Global.join'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }